// extracted by mini-css-extract-plugin
export var icon = "_q1-0";